import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface DocumentDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
}

const DocumentDeleteDialog = ({
  open,
  onOpenChange,
  onConfirm
}: DocumentDeleteDialogProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      console.log("DocumentDeleteDialog: Calling onConfirm...");
      await onConfirm();
      console.log("DocumentDeleteDialog: onConfirm completed.");
      // The dialog closing logic is handled by the parent via onOpenChange
      // if onConfirm successfully calls setDeleteDocumentOpen(false)
    } catch (error) {
      console.error("Error deleting document:", error);
    } finally {
      setIsDeleting(false);
      console.log("DocumentDeleteDialog: Deleting state reset.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={(value) => {
      if (isDeleting) return; // Prevent closing while deleting
      onOpenChange(value);
    }}>
      <DialogContent className="overflow-hidden border-border/70 bg-background/95 p-0 shadow-2xl sm:max-w-[460px]">
        <DialogHeader className="border-b border-border/60 px-6 py-5">
          <DialogTitle>Delete Document</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this document? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="border-t border-border/60 px-6 py-4">
          <Button 
            type="button" 
            variant="secondary"

            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button 
            type="button" 
            variant="destructive" 
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentDeleteDialog;